module.exports = __webpack_public_path__ + "static/media/acacia mall shot 03-mobile.f0ad0034.webp";